import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';


// RxJs
import { Observable, pipe, take } from 'rxjs';
import { map, tap } from 'rxjs/operators';

// Providers
import { SecurityService } from '@core/providers/services/security/security.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private securityService: SecurityService
  ) { }


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    return this.securityService.isAuthenticated(next, state, 'canActivate').pipe(this.logInPipes());
  }


  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    return this.securityService.isAuthenticated(childRoute, state, 'canActivateChild').pipe(this.logInPipes());
  }


  private logInPipes(): any {
    return pipe(
      take(1),
      map(isAuthenticared => {
        // return isAuthenticared ? this.router.createUrlTree(['home']) : this.router.createUrlTree(['401']);
        return isAuthenticared;
      }),
    );
  }
}
